import { useState, useEffect, useMemo } from "react";
import cytoscape from "cytoscape";
import api from "../api/apiClient";

export const useSchemaGraph = (url_base) => {
  const [schemaData, setSchemaData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSchemaData = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/schema/graph`);
        // Filter edges to remove self-loops (edges where source and target are the same)
        const filteredEdges = response?.data?.edges?.filter(
          (edge) => edge.source !== edge.target
        );
        response.data.edges = filteredEdges;
        setSchemaData(response.data);
        setError(null);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSchemaData();
  }, [url_base]);

  const cy = useMemo(() => {
    if (!schemaData) return null;

    const nodes = schemaData.nodes.map((n) => ({
      group: "nodes",
      classes: n.labels.join(" "),
      data: {
        id: n.id.toString(),
        name: n.name,
        display: n.name,
        colour: n.colour,
        labels: n.labels,
        class_kind: n.class_kind,
        src_obj: n,
        props: n.props,
        is_schema: true,
      },
    }));

    const edges = schemaData.edges.map((e) => ({
      group: "edges",
      classes: e.label,
      data: {
        source: e.source.toString(),
        target: e.target.toString(),
        label: e.label,
        display: e.label,
        src_obj: e,
        props: e.props,
        is_schema: true,
      },
    }));

    return cytoscape({
      headless: true,
      elements: {
        nodes: nodes,
        edges: edges,
      },
    });
  }, [schemaData]);

  return { cy, loading, error };
};
